module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.891e3f34.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff
// module id = 2529
// module chunks = 7